<template>
	<div class="login login-form-container" :class="{ mobile: isMobile }">
		<div class="field">
			<label class="label">{{ $t('login.email_label') }}</label>
			<p class="control has-icons-left">
				<input
					required
					class="input"
					type="email"
					:class="wrongCredentials ? 'is-danger' : ''"
					:placeholder="$t('login.email_placeholder')"
					v-model="email"
					@keyup.enter="onLogin"
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-envelope"></i>
				</span>
			</p>
		</div>
		<div class="field">
			<label class="label">{{ $t('login.password_label') }}</label>
			<div class="control has-icons-left">
				<input
					required
					class="input"
					type="password"
					:class="wrongCredentials ? 'is-danger' : ''"
					:placeholder="$t('login.password_placeholder')"
					v-model="password"
					@keyup.enter="onLogin"
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-lock"></i>
				</span>
			</div>
		</div>
		<div class="field">
			<div class="control is-flex is-justify-content-space-between">
				<button
					class="button is-third is-info"
					:disabled="disableLogin"
					:class="loggingIn ? 'is-loading' : ''"
					@click="onLogin"
				>
					{{ $t('login.login_button') }}
				</button>
				<router-link
					style="color: white; text-decoration: underline;"
					to="/recover-password"
				>{{ $t('login.forgot_password') }}</router-link
				>
			</div>
			<transition name="fade">
				<div class="box login-help-box" v-if="wrongCredentials">
					<p class="help login-help-text is-danger">
						{{ helperMessage || $t('login.error_invalid_credentials') }}
					</p>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import PackageJson from '../../../../package.json';
import { mapGetters } from 'vuex';

export default {
	props: {
		loggingIn: Boolean,
		wrongCredentials: Boolean,
		helperMessage: String
	},
	data() {
		return {
			email: '',
			password: '',
			version: ''
		};
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		disableLogin() {
			var validEmail = this.email != '' ? true : false;
			var validPassword = this.password != '' ? true : false;

			return !validEmail || !validPassword ? true : false;
		},
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		onLogin() {
			this.$emit('login', { email: this.email, password: this.password });
		}
	},
	mounted() {
		this.version = PackageJson.version;
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/colors.scss";

.login {
  display: flex;
  flex-flow: column;
  position: relative;
}
.login-help-box {
  position: absolute;
  margin-top: 10px;
  padding: 0px 10px 2px 10px;
  background-color: $dark;
  border-radius: 2px;
  box-shadow: 5px 5px 5px #23282d60 !important;
}
.login-help-text {
  position: relative;
  font-size: 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.button,
.input {
  border-radius: 2px;
  box-shadow: 5px 5px 5px #23282d60 !important;
}
.label {
  text-shadow: 2px 2px #23282d2d;
}
.title {
  text-shadow: 2px 2px #23282d77;
}
.input {
  background: white;
}
.label {
  color: white;
}
.login-header {
	margin-bottom: 30%;
	
  > * {
	color: #ef7c21 !important;
	margin-bottom: 0 !important;
	text-align: center;
  }
}
.field:first-child {
  margin-top: 25%;
}
.login-form-container {
	margin-top: 30vh;
	max-width: 462px;
	&.mobile {
		margin: auto;
	}
}
.button.is-third {
  width: 33%;
  min-width: 100px;
}
.button[disabled].is-info {
  opacity: 1;
}
</style>
